import React, { useEffect } from "react";
import { Row, Col, Container } from "react-bootstrap";
import "./Penaltiesndpending.css";
import { trackEvent, trackPageView } from "../../utils/tracking";
function Penaltiesndpending() {
  // Updated Code
  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/SIDdisclosures/Penaltiesndpending",
      "jmf_sid-disclosures_pending-penalties",
    );
    // trackPageView(
    //   "http://localhost:710/SIDdisclosures/Penaltiesndpending",
    //   "jmf_sid-disclosures_pending-penalties"
    // );

    trackEvent({
      category: "Static Page",
      action: "SIDdisclosures Penalties Pending Page Loaded",
      label: "jmf_sid-disclosures_pending-penalties",
      value: 1,
    });
  }, []);
  // ----------------------------------------------------------------------------------

 return (
  <section 
    className="defin-unit product_fund-summary-sc" 
    tabIndex="0" 
    role="region" 
    aria-label="Penalties and litigation information"
  >
    <Container>
      <Row>
        <Col>
          <div className="penalties-pending">
            <p className="penalties-head">
              Penalties, Pending Litigation or Proceedings, Findings of
              Inspections or Investigations for Which Action May Have Been
              Taken or Is in The Process of Being Taken by Any Regulatory
              Authority. (As on September 30, 2026)
            </p>

            {/* Main Ordered List */}
            <ol className="penalties-list">
              {/* Point 1 */}
              <li>
                All disclosures regarding penalties and action(s) taken
                against foreign Sponsor(s) may be limited to the jurisdiction of
                the country where the principal activities (in terms of income /
                revenue) of the Sponsor(s) are carried out or where the
                headquarters of the Sponsor(s) is situated. Further, only top 10
                monetary penalties during the last five years shall be
                disclosed.
                <br /><br />
                NA
              </li>

              {/* Point 2 + subpoints */}
              <li>
               In case of Indian Sponsor(s), details of all monetary
                penalties imposed and/ or action taken during the last five
                years or pending with any financial regulatory body or
                governmental authority, against Sponsor(s) and/ or the AMC and/
                or the Board of Trustees /Trustee Company; for irregularities or
                for violations in the financial services sector, or for defaults
                with respect to shareholders or debenture holders and
                depositors, or for economic offences, or for violation of
                securities law. Details of settlement, if any, arrived at with
                the aforesaid authorities during the last five years shall also
                be disclosed.

                <ol type="a">
                  <li>
                   The Sponsor of JM Financial Mutual Fund has contingent
                    liability in respect of income tax demand and service tax demand
                    disputed in Rs.56.83 crore as on March 31, 2025 (last reported
                    Rs.50.92 crore as on March 31, 2024).
                  </li>
                  <li>
                   The Income Tax Authorities had ongoing dispute with the
                    Sponsor relating to them treating the long term capital gain on
                    sale of equity shares on termination of joint venture with
                    Morgan Stanley as taxable under the head “Business Income” and
                    not under the head “Capital Gains”. The ITAT has ruled the
                    appeals in favour of JM Financial Ltd (Sponsor), the matter
                    stands closed.
                  </li>
                  <li>
                  SEBI conducted an inspection of the merchant banking
                    operations of JM Financial Limited (“JMFL”) and issued an
                    advisory and deficiency letter dated July 17, 2020 to JMFL in
                    relation to its certain findings, primarily procedural/technical
                    in nature. JMFL, vide its letter dated August 27, 2020, has
                    submitted its representations to SEBI along with the details of
                    proposed corrective steps to rectify the deficiencies mentioned
                    in SEBI letter and accordingly, the matter stands closed.
                  </li>
                  <li>
                    In the matter of a proposed Initial Public Offer (“IPO”) by
                    one of the clients of JM Financial Limited (“JMFL”), there was
                    non- disclosure of certain facts related to the promoters of the
                    issuer company in the Draft Red Herring Prospectus (“DRHP”).
                    SEBI issued an administrative warning letter dated July 21, 2022
                    to the concerned promoters of the issuer company and the Book
                    Running Lead Managers to the IPO, including JMFL, asking them to
                    ensure compliance with SEBI (Issue of Capital and Disclosure
                    Requirements) Regulations, 2018. JMFL took necessary corrective
                    action and accordingly, the matter stands closed.
                  </li>
                  <li>
                    SEBI conducted an inspection of the merchant banking
                    operations of JMFL and issued an administrative warning letter
                    dated June 2, 2023 to JMFL in relation to its certain
                    observations. JMFL, vide its letter dated August 7, 2023, has
                    submitted the details of corrective steps/action taken for the
                    observations made in SEBI letter and accordingly, the matter
                    stands closed.
                  </li>
                  <li>
                    In the matter of an IPO by one of the clients of JMFL, SEBI
                    issued an administrative warning letter dated August 22, 2023 to
                    JMFL for non-reporting of bid upload failure by a Self-Certified
                    Syndicate Bank. JMFL took necessary corrective action and
                    accordingly, the matter stands closed.
                  </li>
                  <li>
                    In the matter of buy-back of equity shares by one of the
                    clients of JMFL, SEBI issued an administrative warning letter
                    dated November 22, 2023 to JMFL in relation to the calculation of
                    entitlement ratio for the general category of shareholders while
                    preparing Letter of Offer. JMFL took necessary corrective action
                    and accordingly, the matter stands closed.
                  </li>
                  <li>
                   SEBI conducted an inspection of the merchant banking
                    operations of JMFL in respect of public issues of NCDs, REITs
                    and InvITs lead managed by it and issued an administrative
                    warning letter dated June 14, 2024 to JMFL in relation to
                    certain observations. JMFL, vide its letter dated July 12, 2024,
                    has submitted the details of corrective steps/action taken for
                    the observations made in SEBI letter. (Matter Closed)
                  </li>
                  <li>
                    In relation to an initial public offer of shares by one of
                    the clients of JMFL, SEBI issued an administrative warning
                    letter dated January 1, 2025, inter-alia, advising JMFL to be
                    more careful in future while exercising due diligence. (Matter
                    closed).
                  </li>
                </ol>
              </li>

              {/* Point 3 + subpoints */}
              <li>
                 Details of all enforcement actions taken by SEBI in the last
                five years and/ or pending with SEBI for the violation of SEBI
                Act, 1992 and Rules and Regulations framed there under including
                debarment and/ or suspension and/ or cancellation and/ or
                imposition of monetary penalty/adjudication/enquiry proceedings,
                if any, to which the Sponsor(s) and/ or the AMC and/ or the
                Board of Trustees / Trustee Company and/ or any of the directors
                and/ or key personnel (especially the fund managers) of the AMC
                and Trustee Company were/ are a party. The details of the
                violation shall also be disclosed.

                <ol type="a">
                  <li>
                    SEBI had issued a show cause notice dated November 15, 2022
                    to JM Financial Asset Management Limited (“the AMC”) and JM
                    Financial Trustee Company Private Limited (“Trustee Company”),
                    in respect of transactions executed by certain employees of the
                    AMC in the schemes of JM Financial Mutual Fund, which was
                    responded to by the AMC and Trustee Company. Post the
                    submissions of the AMC and the Trustee Company, SEBI has issued
                    an Order of the Adjudicating Officer on July 31, 2024 imposing a
                    penalty of INR 25,00,000 and INR 10,00,000 on the AMC and the
                    Trustee Company, respectively... The above penalty was
                    paid by the AMC and Trustee Company on September 04, 2024 and
                    accordingly, the matter stands closed.
                  </li>
                  <li>
                    SEBI, vide its order dated May 10, 2019, disposed of the show
                    cause notice dated March 14, 2019 issued by it to JMFISL...
                    JMFL was acquitted without any action being taken... (Matter closed)
                  </li>
                  <li>
                   SEBI, vide its Settlement Order dated May 21, 2024, disposed
                    of the adjudication proceedings... (Matter closed)
                  </li>
                  <li>
                    In respect of the Orders issued by SEBI against JMFL... 
                    SEBI vide its order dated September 19, 2025... (Matter closed)
                  </li>
                  <li>
                   SEBI, vide its order dated March 20, 2026, disposed of the
                    Show Cause Notice... (Matter closed)
                  </li>
                </ol>
              </li>

              {/* Point 4 */}
              <li>
                Any pending material civil or criminal litigation incidental
                to the business of the Mutual Fund to which the Sponsor(s) and/
                or the AMC and/ or the Board of Trustees /Trustee Company and/
                or any of the directors and/ or key personnel are a party should
                also be disclosed separately.
                <br /><br />
                Nil
              </li>

              {/* Point 5 */}
              <li>
                 Any deficiency in the systems and operations of the
                Sponsor(s) and/ or the AMC and/ or the Board of Trustees/Trustee
                Company which SEBI has specifically advised to be disclosed in
                the SID, or which has been notified by any other regulatory
                agency, shall be disclosed.
                <br /><br />
                N.A.
              </li>
            </ol>
          </div>
        </Col>
      </Row>
    </Container>
  </section>
);
}

export default Penaltiesndpending;
